// extracted by mini-css-extract-plugin
module.exports = {"label":"Inline_label__2e1vx"};